export interface ComponentMapDestination {
  address: string;
}

export function componentExternalUrl(value: unknown): string {
  if (
    typeof value !== 'string' ||
    value.length > 2048 ||
    /[\u0000-\u0020\u007f]/.test(value.trim())
  )
    throw new Error('链接须为有效的 HTTP 或 HTTPS 网页地址');
  let url: URL;
  try {
    url = new URL(value.trim());
  } catch {
    throw new Error('链接须为完整的 HTTP 或 HTTPS 网页地址');
  }
  if (!['http:', 'https:'].includes(url.protocol) || url.username || url.password)
    throw new Error('只允许不含账号密码的 HTTP 或 HTTPS 网页地址');
  return url.href;
}

export function componentMapDestination(value: unknown): ComponentMapDestination {
  if (!value || typeof value !== 'object' || Array.isArray(value))
    throw new Error('导航目的地无效');
  const input = value as Record<string, unknown>;
  if (input.address !== undefined && typeof input.address !== 'string')
    throw new Error('地点地址须为文字');
  const address = typeof input.address === 'string' ? input.address.trim() : '';
  if (address.length > 300 || /[\u0000-\u001f\u007f]/.test(address))
    throw new Error('地点地址最多300字且不能含控制字符');
  if (!address) throw new Error('请先填写地点或地址');
  return { address };
}

export function componentMapLinks(value: unknown) {
  const destination = componentMapDestination(value);
  const label = destination.address;
  const baidu = new URL('https://api.map.baidu.com/direction');
  baidu.search = new URLSearchParams({
    origin: '我的位置',
    destination: label,
    mode: 'driving',
    output: 'html',
    src: 'webapp.lingxi.xingnang',
  }).toString();
  return {
    web: baidu.href,
    android: `geo:0,0?q=${encodeURIComponent(label)}`,
    ios: `https://maps.apple.com/?daddr=${encodeURIComponent(label)}`,
  };
}

// 函数会被序列化注入隔离 iframe，不能引用模块内其他函数。
export function createComponentLinkApi(
  call: (method: string, payload: Record<string, unknown>) => Promise<unknown>,
) {
  return {
    open: (url: string) =>
      call('links.open', { url }) as Promise<{ opened: boolean; review?: boolean }>,
    openMap: (destination: ComponentMapDestination) =>
      call('links.openMap', { destination }) as Promise<{ opened: boolean; review?: boolean }>,
  };
}
